import React, { useState, useEffect } from "react";
import "../assets/css/confirmModal.css";
import logo from "../assets/images/logo.png";

const ConfirmModal = ({ isOpen, onClose, onProceed }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <img src={logo} alt="KPMG Logo" className="modal-logo" />
          <h2 className="modal-title">Whistleblowing Portal</h2>
        </div>

        <p>
          Welcome To The KPMG Whistleblowing Portal Where You Can Report Matters
          Relating To KPMG And KPMG Personnel.
        </p>
        <div className="modal-highlight">
          <p>
            Do you want to make a report under the KPMG EthicsLine relating to a
            non-KPMG entity or person? Please proceed to the{" "}
            <a
              href="http://apps.ng.kpmg.com/ethics/#/"
              className="modal-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              KPMG ETHICS LINE
            </a>{" "}
            to report via the appropriate channel.
          </p>
        </div>
        <p>
          If your report relates to KPMG or KPMG personnel, please proceed on
          this site.
        </p>

        <button className="modal-button" onClick={onProceed}>
          Proceed to Site
        </button>
      </div>
    </div>
  );
};

export default ConfirmModal;
